/* eslint-disable no-underscore-dangle */

import style from './SystemFailure.scss';

const showChatWindow = () => window.zE('webWidget', 'open');

const SystemFailure = () => (
  <div className={style.failureContainer}>
    <div className={style.imageContainer}>
      <img src={`${global.__static__}img/chunkview/camerahead.png`} />
    </div>
    <div className={style.failureContent}>
      <h1 className={style.mainHeading}>Oh fiddlesticks!</h1>
      <h2 className={style.subHeading}>
        Something has gone horribly wrong. It’s a technical issue and it’s
        probably our fault.
      </h2>
      <p>
        We’re truly sorry. And we’ll be looking into the problem right away.
      </p>
      <p>
        You could wait a few moments, and try again, but as always,{' '}
        <a onClick={showChatWindow}>
          get in touch with our friendly support team
        </a>{' '}
        if the issue remains.
      </p>
    </div>
  </div>
);

export default SystemFailure;
